import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Badge, Button, Card, Stack, Text,
} from '@piwikpro/ui-components';
import { useNavigate } from '../../../hooks/useNavigate';
import { App } from '../../../model';
import styles from './WebsiteContent.module.css';

interface WebsiteContentProps {
  appFirstUrl: App['attributes']['urls'][0]
  appId: App['id']
}

const WebsiteContent = ({
  appFirstUrl,
  appId,
}: WebsiteContentProps) => {
  const { t } = useTranslation(['administration']);
  const navigate = useNavigate();

  return (
    <>
      <div className={styles.cardPaddingsOverwrite}>
        <Card connected>
          <Card.Section subdued>
            <Stack vertical>
              <Stack.Item fill>
                <Stack verticalAlignment="center">
                  <Stack.Item>
                    <Badge iconLeft={{ name: 'checkmark', color: 'green', size: 'default' }} color="light-green" size="large" />
                  </Stack.Item>
                  <Stack.Item fill>
                    <Stack vertical spacing="extraNarrow">
                      <Stack.Item>
                        <Stack verticalAlignment="center" spacing="narrow">
                          <Stack.Item>
                            <Text as="p" weight={600} dataId="Label">{t('apps.appCreator.firstAppTrial.firstAppReady')}</Text>
                          </Stack.Item>
                          <Stack.Item>
                            <Badge color="light-green" size="medium" text={appFirstUrl} />
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                      <Stack.Item>
                        <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.firstAppReadyDescription')}</Text>
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>
                </Stack>
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
        <Card connected>
          <Card.Section>
            <Stack verticalAlignment="center">
              <Stack.Item>
                <Badge iconLeft={{ name: 'settings', color: 'blue', size: 'default' }} color="light-blue" size="large" />
              </Stack.Item>
              <Stack.Item fill>
                <Stack vertical spacing="extraNarrow">
                  <Stack.Item>
                    <Text as="p" weight={600} dataId="Label">{t('apps.appCreator.firstAppTrial.basicConfiguration')}</Text>
                  </Stack.Item>
                  <Stack.Item>
                    <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.basicConfigurationDescription')}</Text>
                  </Stack.Item>
                </Stack>
              </Stack.Item>
              <Stack.Item>
                <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.durationTwoMin')}</Text>
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
        <Card connected>
          <Card.Section>
            <Stack verticalAlignment="center">
              <Stack.Item>
                <Badge iconLeft={{ name: 'shield', color: 'blue', size: 'default' }} color="light-blue" size="large" />
              </Stack.Item>
              <Stack.Item fill>
                <Stack vertical spacing="extraNarrow">
                  <Stack.Item>
                    <Text as="p" weight={600} dataId="Label">{t('apps.appCreator.firstAppTrial.privacyConsentTool')}</Text>
                  </Stack.Item>
                  <Stack.Item>
                    <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.privacyConsentToolDescription')}</Text>
                  </Stack.Item>
                </Stack>
              </Stack.Item>
              <Stack.Item>
                <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.durationThreeMin')}</Text>
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </div>
      <Card connected>
        <Card.Section>
          <Stack verticalAlignment="center">
            <Stack.Item>
              <Badge iconLeft={{ name: 'rocket', color: 'blue', size: 'default' }} color="light-blue" size="large" />
            </Stack.Item>
            <Stack.Item fill>
              <Stack vertical spacing="extraNarrow">
                <Stack.Item>
                  <Text as="p" weight={600} dataId="Label">{t('apps.appCreator.firstAppTrial.installingTrackingCode')}</Text>
                </Stack.Item>
                <Stack.Item>
                  <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.installingTrackingCodeDescription')}</Text>
                </Stack.Item>
              </Stack>
            </Stack.Item>
            <Stack.Item>
              <Text as="p" size={12} dataId="Caption" color="InkLighter">{t('apps.appCreator.firstAppTrial.durationThreeMin')}</Text>
            </Stack.Item>
          </Stack>
        </Card.Section>
      </Card>
      <Card>
        <Button
          appearance="constructive"
          iconRight="arrow-right"
          text={t('apps.appCreator.firstAppTrial.letsGo')}
          onClick={() => navigate({
            to: '/administration/apps/$appId/data-collection',
            params: { appId },
            search: { __adminOverlay: 'o/app-creator', prefilled: true, type: 'website' },
          })}
          fullWidth
        />
      </Card>
    </>
  );
};

export default WebsiteContent;
